import React from 'react';
import { Outlet } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/scss/customer/main.scss';
import StoreHeader from '../../components/StoreHeader';
import StoreFooter from '../../components/StoreFooter';
import { getStoreRoutesList } from '../../routes/index.routes';
import { Container } from 'react-bootstrap';
import StoreAuthLayout from '../../layouts/app/store.app.layout';

function StoreLayout() {
  const getStoreRoutesLists = getStoreRoutesList();

  return (
    <>
      <StoreAuthLayout>
        <StoreHeader routes={getStoreRoutesLists} />
        <main className="becomePage becomePage_fan becomePage_affiliate">
          <Container>
            <Outlet />
          </Container>
        </main>
        <StoreFooter isStore={true} routes={getStoreRoutesLists} />
      </StoreAuthLayout>
    </>
  );
}

export default React.memo(StoreLayout);
